(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icons-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('[data-icons-subscribe]');
    forms.forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      var input = form.querySelector('input[type="email"]');
      var honey = form.querySelector('input[name="company_website"]');
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('[data-status]');
      var company = form.dataset.klaviyoCompany;
      var listId = form.dataset.klaviyoList;

      function setStatus(msg, state) {
        if (!status) return;
        status.textContent = msg || '';
        status.dataset.state = state || '';
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (honey && honey.value) return;

        var email = (input.value || '').trim();
        var valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
        if (!valid) { setStatus(form.dataset.msgInvalid, 'error'); input.focus(); return; }
        if (!company || !listId) { setStatus(form.dataset.msgError, 'error'); return; }

        button.disabled = true;
        setStatus(form.dataset.msgLoading, 'loading');

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'revision': '2026-04-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'ICONS Landing Page',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).then(function (res) {
          if (res.status === 202 || res.ok) {
            form.reset();
            setStatus(form.dataset.msgSuccess, 'success');
            button.textContent = form.dataset.msgSuccess;
          } else {
            button.disabled = false;
            setStatus(form.dataset.msgError, 'error');
          }
        }).catch(function () {
          button.disabled = false;
          setStatus(form.dataset.msgError, 'error');
        });
      });
    });

    // Any anchor pointing at the subscribe section moves focus into that
    // section's email field once the scroll settles. Bind by href rather than
    // by a hero-specific class: the type-only hero uses .icons-lp__cta, and
    // binding a single class silently no-ops on the other hero style.
    var ctas = document.querySelectorAll('a[href="#icons-subscribe"]');
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function () {
        var target = document.getElementById('icons-subscribe');
        var el = target && target.querySelector('input[type="email"]');
        if (el) {
          setTimeout(function () {
            el.focus({ preventScroll: true });
          }, 500);
        }
      });
    });
  })();

  (function () {
    var root = document.querySelector('[data-icons-hero]');
    if (!root || root.dataset.heroBound === 'true') return;
    root.dataset.heroBound = 'true';

    var qEl = root.querySelector('[data-hero-q]');
    var dotsEl = root.querySelector('[data-hero-dots]');
    var dataEl = root.querySelector('[data-hero-questions]');
    var liveEl = root.querySelector('[data-hero-live]');
    if (!qEl || !dataEl) return;

    var QUESTIONS;
    try { QUESTIONS = JSON.parse(dataEl.textContent) || []; } catch (e) { QUESTIONS = []; }
    if (QUESTIONS.length === 0) { QUESTIONS = [qEl.textContent]; }

    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, busy = false, timer = null, started = false;

    var saveData = !!(navigator.connection && navigator.connection.saveData);

    // GSAP drives the kinetic reveal only when motion is allowed. Under
    // reduced-motion the hero already falls back to an opacity fade, so
    // fetching 71KB would be pure waste.
    if (!reduce && !window.gsap && root.dataset.gsapSrc) {
      var gs = document.createElement('script');
      gs.src = root.dataset.gsapSrc;
      gs.defer = true;
      document.head.appendChild(gs);
    }

    // The backdrop video is decorative. Phones, reduced-motion users, and
    // Save-Data users keep the poster image instead of pulling an MP4.
    (function () {
      var video = root.querySelector('[data-hero-video]');
      var payload = root.querySelector('[data-hero-video-sources]');
      if (!video || !payload) return;
      var wideEnough = matchMedia('(min-width: 750px)').matches;
      if (reduce || saveData || !wideEnough) return;

      var sources;
      try {
        sources = JSON.parse(payload.textContent);
      } catch (e) {
        return;
      }
      if (!sources || !sources.length) return;

      sources.forEach(function (s) {
        var el = document.createElement('source');
        el.src = s.src;
        el.type = s.type;
        video.appendChild(el);
      });
      video.load();
    })();

    // dots (buttons, keyboard-operable). The container is aria-hidden while empty
    // (no-JS); now that it holds focusable buttons, expose it to assistive tech.
    dotsEl.removeAttribute('aria-hidden');
    var dots = [];
    QUESTIONS.forEach(function (_, i) {
      var b = document.createElement('button');
      b.className = 'icons-hero__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Question ' + (i + 1));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () { if (liveEl) { liveEl.textContent = QUESTIONS[i]; } go(i); });
      dotsEl.appendChild(b); dots.push(b);
    });
    function setDots(n) { dots.forEach(function (d, i) { if (i === n) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }

    function build(text) {
      qEl.innerHTML = '';
      var words = text.split(' ');
      words.forEach(function (word, i) {
        var w = document.createElement('span'); w.className = 'w';
        var inner = document.createElement('span'); inner.className = 'i';
        inner.textContent = word;
        w.appendChild(inner); qEl.appendChild(w);
        // inter-word space as a text node OUTSIDE the overflow:hidden .w, so it
        // renders and offers a wrap opportunity (a trailing space inside .w is clipped)
        if (i < words.length - 1) { qEl.appendChild(document.createTextNode(' ')); }
      });
      return qEl.querySelectorAll('.i');
    }

    function enter(text) {
      var inners = build(text);
      if (reduce || !window.gsap) { qEl.style.opacity = 0; requestAnimationFrame(function () { qEl.style.transition = 'opacity .4s ease'; qEl.style.opacity = 1; }); return; }
      window.gsap.set(inners, { yPercent: 118, opacity: 0, filter: 'blur(7px)' });
      window.gsap.to(inners, { yPercent: 0, opacity: 1, filter: 'blur(0px)', duration: 0.95, ease: 'expo.out', stagger: 0.055 });
    }

    function go(n) {
      if (busy || n === idx) return; busy = true;
      if (reduce || !window.gsap) {
        qEl.style.transition = 'opacity .3s ease'; qEl.style.opacity = 0;
        setTimeout(function () { idx = n; setDots(n); enter(QUESTIONS[n]); busy = false; }, 300);
        return;
      }
      var inners = qEl.querySelectorAll('.i');
      window.gsap.to(inners, { yPercent: -72, opacity: 0, filter: 'blur(7px)', duration: 0.44, ease: 'power2.in', stagger: 0.022,
        onComplete: function () { idx = n; setDots(n); enter(QUESTIONS[n]); busy = false; } });
    }
    function next() { go((idx + 1) % QUESTIONS.length); }

    function startAuto() {
      if (reduce || started) return; started = true;
      // qEl already shows QUESTIONS[0] server-side; wrap it for animation parity
      enter(QUESTIONS[0]);
      function pause() { clearInterval(timer); }
      function resume() { clearInterval(timer); timer = setInterval(next, 4600); }
      resume();
      // pause the auto-rotation on hover AND on keyboard focus (WCAG 2.2.2)
      root.addEventListener('pointerenter', pause);
      root.addEventListener('pointerleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
    }

    // lazy-init when in view; GSAP may still be loading (deferred) — poll briefly
    function boot() {
      var tries = 0;
      (function waitGsap() {
        if (window.gsap || reduce || tries > 40) { startAuto(); return; }
        tries++; setTimeout(waitGsap, 50);
      })();
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); boot(); } });
      }, { rootMargin: '0px' });
      io.observe(root);
    } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-press-copy]').forEach(function (button) {
      var group = button.closest('.press-kit__boilerplate');
      if (!group) return;
      var quote = group.querySelector('[data-press-quote]');
      var status = group.querySelector('[data-press-copied]');
      if (!quote || !navigator.clipboard || !navigator.clipboard.writeText) return;

      // Only reveal the button once we know the API exists — a copy button
      // that silently does nothing is worse than no button.
      button.hidden = false;

      button.addEventListener('click', function () {
        navigator.clipboard.writeText(quote.innerText.trim()).then(
          function () {
            if (status) status.textContent = button.dataset.copiedLabel || 'Copied';
          },
          function () {
            if (status) status.textContent = 'Press Ctrl+C to copy';
          }
        );
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
